import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { statisticsRoutesConfig } from 'domains/statistics/routes';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';

export const useRedirectForPartners = () => {
  const navigate = useNavigate();

  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  useEffect(() => {
    if (!isPartnerStatusLoading && isPartnerClient) {
      navigate(statisticsRoutesConfig.statistics.path, { replace: true });
    }
  }, [isPartnerClient, isPartnerStatusLoading, navigate]);
};
